export default "__VITE_ASSET__C_cOjtp4__"